import React from 'react'
import $ from 'lib/jquery'
import moment from 'lib/moment-timezone-custom'
import ScheduleBase from 'frontend/schedule/schedule-base'
import LocationSelect from 'frontend/schedule/location-select'
import PlayersCountInput from 'frontend/schedule/players-count-input'
import MinPriceIndicator from 'frontend/schedule/min-price-indicator'
import TimeSelect from 'frontend/schedule/time-select'
import RoomSegment from 'frontend/schedule/room-segment'
import CommonIcons from 'frontend/components/common-icons'
import AttributeFilterSelect from 'frontend/components/attribute-filter-select'
import memoizeOne from 'memoize-one'
import ReactSelect from 'react-select'
import params from 'lib/params'
import Current from 'frontend/lib/current'

export default class Schedule extends ScheduleBase {
  constructor (props) {
    super(props)

    const selectedFilterLocationId = parseInt(params.get('selectedFilterLocationId'))

    this.initialState = {
      selectedFilterLocationId: isNaN(selectedFilterLocationId) ? null : selectedFilterLocationId,
      selectedDate: params.get('selectedDate') ? moment(params.get('selectedDate')) : moment(),
      selectedTimeRange: null,
      selectedPlayersCount: null,
      selectedGenre: null,
      selectedInteractionType: params.get('selectedInteractionType') || 'physical',
    }

    Object.freeze(this.initialState)

    this.memoizedFilterRoomsList = memoizeOne(this.filterRoomsList)

    this.state = Object.assign(this.state, Object.assign({}, this.initialState))
  }

  componentDidMount () {
    super.componentDidMount()
    this.fetchLocations()
  }

  updateSchedule () {
    const { selectedDate, selectedInteractionType, selectedFilterLocationId } = this.state
    const formattedDate = selectedDate.format('YYYY-MM-DD')

    this.fetchSchedule({
      url: '/' + Current.cityId + '/schedule.json',
      data: {
        dateFrom: formattedDate,
        dateTo: formattedDate,
        interactionType: selectedInteractionType,
        locationId: selectedFilterLocationId,
      },
      success: function (schedule) {
        if (this.state.locations) {
          this.mergeLocationsWithSchedule(this.state.locations, schedule)
        }
        this.constructor.processRooms(schedule.rooms)
        this.setInteractionTypeLabel({
          selectedInteractionType: this.state.selectedInteractionType,
          interactionTypes: schedule.interactionTypes,
        })
        this.setState({ schedule })
      }.bind(this),
    })
  }

  fetchLocations () {
    $.ajax({
      type: 'get',
      url: '/' + Current.cityId + '/locations.json',
      error: function (response) {
        console.error('Schedule: error fetching locations.json', response)
        this.setState({ errorMessage: 'Error fetching locations from server' })
      }.bind(this),
      success: function (response) {
        if (this.state.schedule) {
          this.mergeLocationsWithSchedule(response, this.state.schedule)
        }

        this.setState({ locations: response })
      }.bind(this),
    })
  }

  mergeLocationsWithSchedule (locations, schedule) {
    if (locations && schedule) {
      schedule.rooms.forEach(
        function (room) {
          locations.forEach(
            function (location) {
              if (room.locationId === location.id) {
                room.location = location
              }
            },
          )
        },
      )
    }
  }

  handleLocationSelect (location) {
    params.setWithHistory('selectedFilterLocationId', location?.id)
    this.setState({ selectedFilterLocationId: location?.id }, () => {
      this.updateSchedule()
    })
  }

  handleTimeRangeSelect (selectedTimeRange) {
    this.setState({ selectedTimeRange })
  }

  handleInteractionTypeSelect ({ value: selectedInteractionType, label: selectedInteractionTypeLabel }) {
    this.setState({ selectedInteractionType, selectedInteractionTypeLabel }, () => {
      params.setWithHistory('selectedInteractionType', selectedInteractionType)
      this.updateSchedule()
    })
  }

  setInteractionTypeLabel ({ interactionTypes, selectedInteractionType }) {
    if (!interactionTypes || !selectedInteractionType) return

    const option = interactionTypes.find(option => option.value === selectedInteractionType)
    option && this.setState({ selectedInteractionTypeLabel: option.label })
  }

  handleGenreSelect (selectedGenre) {
    this.setState({ selectedGenre })
  }

  handleResetFilters () {
    this.setState(this.initialState)
  }

  playersCountFilterChange (playersCount) {
    this.setState({
      selectedPlayersCount: playersCount,
      selectedPlayersCountFilter: playersCount,
    })
  }

  renderLocationsSelect () {
    if (this.state.locations) {
      return (
        <LocationSelect
          key={this.state.selectedFilterLocationId}
          locations={this.state.locations}
          selectedId={this.state.selectedFilterLocationId}
          onChange={this.handleLocationSelect.bind(this)}
        />
      )
    } else {
      return <div className="loading">Loading...</div>
    }
  }

  renderFilters () {
    return (
      <div className="filters">
        <div className="players_count_place section">
          <h5 className="title">Select number of players</h5>
          <div className="players_count_input_with_price_indicator">
            <PlayersCountInput
              minPlayers={this.state.schedule.minPlayers}
              maxPlayers={this.state.schedule.maxPlayers}
              value={this.state.selectedPlayersCountFilter}
              onChange={this.playersCountFilterChange.bind(this)}
            />
            <MinPriceIndicator
              playersCount={this.state.selectedPlayersCountFilter}
              playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            />
          </div>
        </div>
        <div className="locations_place section">
          <h5 className="title">Select location</h5>
          {this.renderLocationsSelect()}
        </div>
        <div className="time_place section">
          <h5 className="title">Select time</h5>
          <TimeSelect
            selected={this.state.selectedTimeRange}
            onChange={this.handleTimeRangeSelect.bind(this)}
          />
        </div>
        <div className="time_place section">
          <h5 className="title">Experience type</h5>
          <ReactSelect
            className="schedule_interaction_type_select"
            searchable={false}
            clearable={false}
            name="date-select"
            placeholder={this.state.selectedInteractionTypeLabel}
            options={this.state.schedule.interactionTypes}
            onChange={option => this.handleInteractionTypeSelect(option)}
            aria-label="Experience Type Select"
          />
        </div>
        <div className="genere_place section">
          <h5 className="title">Select genre</h5>
          <AttributeFilterSelect
            collection={this.state.schedule.rooms}
            attribute="genre"
            className="schedule_genre_select"
            selected={this.state.selectedGenre}
            onChange={this.handleGenreSelect.bind(this)}
          />
        </div>
        <div className="reset_button_place section">
          <button className="reset" onClick={this.handleResetFilters.bind(this)} aria-label="Reset Filters">
            <CommonIcons item="common-times" className="icon" />
            reset all
          </button>
        </div>
      </div>
    )
  }

  renderSchedule () {
    const {
      schedule, selectedFilterLocationId, selectedInteractionType, selectedPlayersCountFilter, selectedGenre,
    } = this.state
    return (
      <div className="rooms">
        {this.memoizedFilterRoomsList(
          schedule.key, selectedFilterLocationId, selectedInteractionType, selectedPlayersCountFilter, selectedGenre,
        )}
      </div>
    )
  }

  filterRoomsList (_key, selectedFilterLocationId, selectedInteractionType, selectedPlayersCountFilter, selectedGenre) {
    return this.state.schedule?.rooms?.map((room) => {
      if (selectedFilterLocationId && selectedFilterLocationId !== room.location.id) return
      if (selectedPlayersCountFilter
        && (room.minPlayers > selectedPlayersCountFilter || room.maxPlayers < selectedPlayersCountFilter)) return
      if (selectedGenre && room.genre !== selectedGenre) return

      return (
        <RoomSegment
          key={room.id}
          room={room}
          schedule={this.state.schedule}
          selectedTimeRange={this.state.selectedTimeRange}
          selectedSlot={this.state.selectedSlot}
          selectedDate={this.state.selectedDate}
          selectedTime={this.state.selectedTime}
          selectedRoom={this.state.selectedRoom}
          selectedPlayersCount={this.state.selectedPlayersCount}
          cartItems={this.state.cartItems}
          onSlotSelect={this.handleSlotSelect.bind(this)}
          onGameRemove={this.handleGameRemove.bind(this)}
          onPlayersCountSelect={this.handlePlayersCountSelect.bind(this)}
        />
      )
    })
  }
}
